import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import refs from '../helpers/refs'
import site from '../helpers/site'

class CImageGalleryNew {
  constructor (el) {
    this.hero = el
    this.$refs = refs(this.hero)
    this.site = site()
    this.init()
  }

  init () {
    this.initProductImageSlider()
    this.initControlButtonClick()
    this.setupImageThumbnailClick()
    this.setupKeyDownForThumbnail()
    this.setupKeyDownForImageGallery()
    this.hideScrollbarIfNothingToScroll()
  }

  initProductImageSlider () {
    const glideElem = document.querySelector('.c-product-hero__glide')
    if (glideElem) {
      this.glide = new Glide(glideElem, { type: 'slider', rewind: false })
        .mount({ Controls, Keyboard, Breakpoints, Swipe })
      this.glide.on('run', () => {
        this.updateActiveControlButton()
      })
    }
  }

  updateActiveControlButton () {
    const activeIndex = this.glide.index
    const galleryImageCount = this.hero.querySelectorAll('.c-image-gallery__image').length
    const newIndex = activeIndex + 1 % galleryImageCount

    if (isNaN(newIndex)) { return }

    const oldActiveControl = this.hero.querySelector('.c-image-gallery__block.active')
    const newActiveControl = this.hero.querySelector(`.c-image-gallery__block:nth-child(${newIndex})`)
    console.log('old active', oldActiveControl, 'new active', newActiveControl)

    if (oldActiveControl) { oldActiveControl.classList.remove('active') }
    newActiveControl.classList.add('active')
  }

  initControlButtonClick () {
    this.$refs.buttons.addEventListener('click', (e) => {
      const selectedIndex = parseInt(e.target.getAttribute('data-index'))
      // this.showHeroImage(selectedIndex)
      this.glide.go(`=${selectedIndex}`)
    })
  }

  setupImageThumbnailClick () {
    // On image thumbnail click
    this.$refs.imageScroll.addEventListener('click', (e) => {
      const selectedIndex = parseInt(e.target.getAttribute('data-index'))
      // this.showHeroImage(selectedIndex)
      this.glide.go(`=${selectedIndex}`)
      e.target.focus() // focus on the thumbnail
    })
  }

  setupKeyDownForThumbnail () {
    this.$refs.imageScroll.addEventListener('keydown', (e) => {
      // Enter or spacebar
      if (e.keyCode === 13 || e.keyCode === 32) {
        const selectedIndex = parseInt(e.target.getAttribute('data-index') ?? e.target.querySelector('img').getAttribute('data-index'))
        // this.showHeroImage(selectedIndex)
        this.glide.go(`=${selectedIndex}`)
      }
    })
  }

  setupKeyDownForImageGallery () {
    this.hero.addEventListener('keydown', (e) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) { return }
      if (e.keyCode === 37) { this.glide.go('<') } else if (e.keyCode === 39) { this.glide.go('>') }

      const activeIndex = this.glide.index
      const thumbnail = document.querySelector(`.c-image-gallery__image [data-index="${activeIndex}"]`)
      thumbnail.parentElement.focus() // focus on the thumbnail
    })
  }

  hideScrollbarIfNothingToScroll () {
    const scroller = this.$refs.imageScroll
    let timeout
    const setScrollbarVisibility = () => {
      scroller.style['overflow-x'] = (scroller.clientWidth + 20 < scroller.scrollWidth) ? 'scroll' : 'hidden'
    }
    const withTimeout = (cb, time) => {
      if (timeout) { clearTimeout(timeout) }
      timeout = setTimeout(cb, time)
    }

    setScrollbarVisibility()
    window.addEventListener('load', setScrollbarVisibility)
    window.addEventListener('resize', () => withTimeout(setScrollbarVisibility, 50))
  }
}

// all unified on new version
window.addEventListener('load', () => {
  document.querySelectorAll('[data-c-image-gallery]').forEach(el => new CImageGalleryNew(el))
})

/*
Old version from original MB/KJ. Required a lot of vertical scrolling to get past gallery.
Replaced 2/2024. Leaving the code here in case they change their minds.
Give it a year or so and delete to the end of the file. DLL

class CImageGalleryMBKJ {
  constructor (el) {
    this.hero = el
    this.$refs = refs(this.hero)
    this.site = site()
    this.init()
  }

  init () {
    this.preloadHeroImages()
    this.initGallery()
    this.handleMainImageClick()
    this.handleImageScroll()
    this.$refs.buttons.addEventListener('click', this.smoothScroll)
  }

  preloadHeroImages () {
    const heroImages = this.hero.querySelectorAll('data-image-600')
    for (let i = 0; i < heroImages.length; i++) {
      const img = new Image()
      img.src = heroImages[i].getAttribute('data-image-600')
    }
  }

  handleMainImageClick () {
    document.querySelector('[ref="imageOuter"]').addEventListener('click', (e) => {
      if (this.$refs.galleryOverlay) { this.$refs.galleryOverlay.classList.replace('hidden', 'flex') }
      // window.location.hash = `#image_${e.target.getAttribute('data-index')}`
    })
  }

  handleImageScroll () {
    this.$refs.imageScroll.addEventListener('scroll', (e) => {
      const scrollRange = e.target.scrollWidth - e.target.offsetWidth
      const blockWidth = scrollRange / 6
      const currentBlock = 6 - Math.round((scrollRange - e.target.scrollLeft) / blockWidth)

      const bgClass = this.site === 'masterbuilt' ? 'bg-grey-700' : 'bg-grey-800'
      for (let i = 0; i < 7; i++) {
        const block = document.getElementById('c-image-gallery__button-' + i)
        currentBlock === i
          ? block.classList.replace('c-image-gallery__block', bgClass)
          : block.classList.replace(bgClass, 'c-image-gallery__block')
      }
    })
  }

  smoothScroll (e) {
    const scroll = document.getElementById('c-image-gallery__scroll')
    const scrollRange = scroll.scrollWidth - scroll.offsetWidth
    if (e.path) {
      const blockWidth = scrollRange / (e.path[1].childElementCount - 1)
      const buttonNumber = parseInt(e.path[0].id.replace('c-image-gallery__button-', ''))
      scroll.scroll({ left: blockWidth * buttonNumber, behavior: 'smooth' })
    } else { console.warn('No path found for image gallery button') }
  }

  initGallery () {
    this.handleThumbnailClick()
    if (this.$refs.closeOverlay) {
      this.$refs.closeOverlay.addEventListener('click', (e) => {
        if (this.$refs.galleryOverlay) { this.$refs.galleryOverlay.classList.replace('flex', 'hidden') }
      })
    }
  }

  handleThumbnailClick () {
    this.$refs.imageScroll.addEventListener('click', (e) => {
      if (this.$refs.galleryOverlay) { this.$refs.galleryOverlay.classList.replace('hidden', 'flex') }
    })
  }
}
*/

// To make things easier to follow and maintain,
// we're splitting the code between the old/new gallery into separate classes
/*
if (site() === 'chargriller') {
  window.addEventListener('load', () => {
    document.querySelectorAll('[data-c-image-gallery]').forEach(el => new CImageGalleryCG(el))
  })
} else {
  window.addEventListener('load', () => {
    document.querySelectorAll('[data-c-image-gallery]').forEach(el => new CImageGalleryMBKJ(el))
  })
}
*/
